module.exports = __webpack_public_path__ + "static/media/mustafa.fd628cf8.png";